export class ReportParameterModel {
    startDate?: string;
    endDate?: string;
}

export class ReportConstants {
    public static ReportDataApiCall: string = 'GetReportData';
}
